import React from 'react'
import { useNode } from 'react-pagebuilder/hooks/useNode'
import { useEditor } from 'react-pagebuilder/hooks/useEditor'
import { AttivitaCard as Original } from 'components/molecules'
import { AttivitaCardSettings, AttivitaCardFloatingSettings } from './AttivitaCardSettings'
import { withBlock } from '../withBlock'
import { withCraft } from '../withCraft'
import {
  ctaDefaultProps,
  ctaItemParams,
} from 'react-pagebuilder/editor/Viewport/Sidebar/Toolbar/CtaToolbarSection'
import {
  imageDefaultProps,
  imageItemParams,
} from 'react-pagebuilder/editor/Viewport/Sidebar/Toolbar/ImageToolbarSection'

export const defaultProps = {
  ...ctaDefaultProps('Button', null, null, ''),
  ...imageDefaultProps(),
}

export const attivitaCardItemParams = (enabled, id, blockProps, children) => ({
  ...ctaItemParams(blockProps, enabled),
  ...imageItemParams(blockProps),
  pk: id,
})

export const dynamicProps = []

export const AttivitaCard: any = withBlock(
  (props) => {
    const blockProps = {
      ...defaultProps,
      ...props.block,
    }

    const { children } = props

    const _ = props.renderValue

    const {
      id,
      connectors: { connect },
      selected,
      hovered,
      actions: { setProp, setCustom },
      customs,
    } = useNode(
      (state) => ({
        selected: state.events.selected,
        dragged: state.events.dragged,
        hovered: state.events.hovered,
        customs: state.data.custom,
      }),
      props
    )

    const { enabled } = useEditor(
      (state) => ({
        enabled: state.options.enabled,
      }),
      props
    )

    return (
      <div ref={(ref) => props.retRef(ref)} className={`block-attivita-card ${props.className}`}>
        <Original
          item={attivitaCardItemParams(enabled, id, blockProps, children)}
          editMode={enabled}
        />
      </div>
    )
  },
  defaultProps,
  dynamicProps
)

AttivitaCard.craft = withCraft({
  name: 'AttivitaCard',
  defaultProps: defaultProps,
  settings: AttivitaCardSettings,
  floatingSettings: AttivitaCardFloatingSettings,
})
